module.exports = __webpack_public_path__ + "img/ch08_09_上扶梯.195ac616.jpg";